export const getTiposLeito = state => {
    return state.tiposLeito;
};

export const getMapaTipoLeito = state => {
    return state.mapaTipoLeito;
};

export const getTipoLeitoFiltradoStatus = state => {
    return state.tipoLeitoFiltradoStatus;
};

export const getQuantitativoLeitosLivres = state => {
    return state.leitos.livres;
};

export const getQuantitativoLeitosCedidos = state => {
    return state.leitos.cedidos;
};
